<template>
	<Layout>
	  <Content :style="{'padding': '10px'}">
    <div>
		<Card>
			<span class="search_span_width_part1">队列列表：</span>
			<Tag type="dot" :key="key" v-for="(item,key) in video_user_list" closable>{{ item }}</Tag>
		</Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="video_concurrency"></Table>
        </Card>
    </div>
	</Content>
	<Modal v-model="group_process_modal" draggable sticky scrollable title="分组中正处理">
		<Select style="width:200px" @on-change="getProcessList">
		    <Option v-for="item in group_process_list" :value="item" :key="item">{{ item }}</Option>
		</Select>
		<Input v-model="video_process_list_len" width="50" />
		<Input v-model="video_process_list" type="textarea" :rows="7" />
	</Modal>
	</Layout>
</template>
<script>
export default {
    data() {
        return {
			video_concurrency:[],
			video_user_list:[],
			list_id:'',
			group_process_list:[],
			group_process_modal:false,
			video_process_list:'',
			video_process_list_len:0,
			tableColumns:[
				{ title: '分组ID', key: 'video_group', align: 'center' },
				{ title: '公司', key: 'company', align: 'center' },
				{ title: '分组名称', key: 'group_name', align: 'center' },
				{ title: '适用端', key: 'client', align: 'center' },
				{ title: '并发数', key: 'video_concurrence', align: 'center' },
				{ title: '处理中', key: 'processing_list', align: 'center',
					render:(h,params) =>{
						let btns=[]
						btns.push(
							h('Button', {
							  props: {type: 'text',size: 'small'},
							  on: {
								click: () => {
									this.group_process_list = params.row.processing_list;
									this.video_process_list = '';
									this.video_process_list_len = 0;
									this.group_process_modal = true;
								}
							  }
							}, params.row.processing_list.length));
						return h("div",btns);
					}
				}
			]
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
		getData(){
			this.http1.get('/monitor/VideoQueue').then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				console.log(data)
				this.video_concurrency = data.data.video_group;
				this.video_user_list = data.data.video_user_list;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		getProcessList(list_id){
			this.http1.get('/monitor/queueList',{params:{list_id:list_id}}).then(response=>{
			  let data=response.data;
			  if(data.code!==0)
			  {
				alert(data.message);
			  } else{
				console.log(data)
				this.video_process_list = JSON.stringify(data.data.list);
				this.video_process_list_len = data.data.list.length;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		}
    },
    watch: {
        
    },
}
</script>
<style  scoped>

</style>
